import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useTranslation } from 'react-i18next'

interface DeleteProfileDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  profileName: string
}

export function DeleteProfileDialog({
  isOpen,
  onClose,
  onConfirm,
  profileName,
}: DeleteProfileDialogProps) {
  const { t } = useTranslation()
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('forward.deleteProfile')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('forward.deleteProfileConfirm', { name: profileName })}
            <br />
            <br />
            {t('forward.deleteProfileWarning')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>{t('global.button.cancel')}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {t('global.button.delete')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
